module.exports = __webpack_public_path__ + "static/media/tooth.91aa7122.svg";